// Staff permissions and the built-in roles. Labels are what a non-technical owner reads.

export const PERMISSIONS = {
  'dashboard.view': 'دیدن داشبورد',
  'reports.view': 'دیدن گزارش‌ها',
  'products.view': 'دیدن محصولات',
  'products.edit': 'افزودن و ویرایش محصولات',
  'products.delete': 'بایگانی و حذف محصولات',
  'inventory.adjust': 'تغییر موجودی انبار',
  'orders.view': 'دیدن سفارش‌ها',
  'orders.manage': 'مدیریت سفارش‌ها و ارسال',
  'orders.refund': 'بازپرداخت و مرجوعی',
  'customers.view': 'دیدن مشتریان',
  'customers.edit': 'ویرایش مشتریان و یادداشت',
  'customers.export': 'خروجی گرفتن از مشتریان',
  'promotions.manage': 'تخفیف‌ها و کمپین‌ها',
  'shipping.manage': 'روش‌ها و قوانین ارسال',
  'content.manage': 'محتوای فروشگاه و صفحه اصلی',
  'notifications.send': 'ارسال اعلان',
  'support.manage': 'پشتیبانی مشتریان',
  'settings.manage': 'تنظیمات فروشگاه',
  'payments.manage': 'تنظیمات پرداخت',
  'staff.manage': 'کارکنان و دسترسی‌ها',
  'audit.view': 'دیدن گزارش فعالیت‌ها',
  'data.import': 'ورود و خروج اطلاعات (اکسل)',
  'backups.manage': 'پشتیبان‌گیری',
} as const;
export type Permission = keyof typeof PERMISSIONS;
export const ALL_PERMISSIONS = Object.keys(PERMISSIONS) as Permission[];

export const PERMISSION_GROUPS: { title: string; items: Permission[] }[] = [
  { title: 'فروش', items: ['dashboard.view', 'reports.view', 'orders.view', 'orders.manage', 'orders.refund'] },
  { title: 'کاتالوگ و انبار', items: ['products.view', 'products.edit', 'products.delete', 'inventory.adjust', 'data.import'] },
  { title: 'مشتریان و بازاریابی', items: ['customers.view', 'customers.edit', 'customers.export', 'promotions.manage', 'notifications.send', 'support.manage'] },
  { title: 'فروشگاه', items: ['content.manage', 'shipping.manage', 'settings.manage', 'payments.manage'] },
  { title: 'امنیت', items: ['staff.manage', 'audit.view', 'backups.manage'] },
];

export const SYSTEM_ROLES: { key: string; name: string; description: string; permissions: Permission[] | ['*'] }[] = [
  { key: 'owner', name: 'مالک', description: 'دسترسی کامل به همه بخش‌ها', permissions: ['*'] },
  {
    key: 'admin', name: 'مدیر', description: 'همه بخش‌ها به جز کارکنان، پرداخت و پشتیبان‌گیری',
    permissions: ALL_PERMISSIONS.filter((p) => !['staff.manage', 'payments.manage', 'backups.manage'].includes(p)),
  },
  {
    key: 'manager', name: 'مدیر فروش', description: 'سفارش، محصول، تخفیف و گزارش',
    permissions: ['dashboard.view', 'reports.view', 'products.view', 'products.edit', 'inventory.adjust', 'orders.view', 'orders.manage', 'orders.refund', 'customers.view', 'customers.edit', 'promotions.manage', 'notifications.send', 'support.manage'],
  },
  { key: 'inventory', name: 'انباردار', description: 'محصولات و موجودی انبار', permissions: ['dashboard.view', 'products.view', 'products.edit', 'inventory.adjust', 'data.import'] },
  { key: 'orders', name: 'مسئول سفارش‌ها', description: 'پردازش، ارسال و پیگیری سفارش‌ها', permissions: ['dashboard.view', 'orders.view', 'orders.manage', 'customers.view', 'support.manage'] },
  { key: 'content', name: 'مسئول محتوا', description: 'صفحه اصلی، بنرها، صفحات و اعلان‌ها', permissions: ['dashboard.view', 'products.view', 'content.manage', 'notifications.send'] },
  { key: 'support', name: 'پشتیبانی', description: 'پاسخ به مشتریان و دیدن سفارش‌ها', permissions: ['orders.view', 'customers.view', 'support.manage'] },
];

export function hasPermission(granted: readonly string[], needed: Permission): boolean {
  return granted.includes('*') || granted.includes(needed);
}
